import PageShell from "../components/PageShell";

export default function ContactPage() {
  return (
    <PageShell pageClass="page-contact">
      <section className="container contact-page">
        <h1>Contacts</h1>
        <div className="contact-box">
          <form className="contact-fields">
            <input type="text" placeholder="Name" />
            <div className="contact-row">
              <input type="email" placeholder="Mail" />
              <input type="text" placeholder="Number" />
            </div>
            <textarea rows="5" placeholder="Your message"></textarea>
          </form>
        </div>

        <div className="btn-box">
          <a className="email-btn" href="mailto:thebiswajitnandistudio@gmail.com">
            <span>Email</span>
            <img src="/assets/image/image copy.jpg" alt="Email icon" />
          </a>
          <a className="whatsapp-btn" href="#">
            <span>Direct Message</span>
            <img src="/assets/image/image.png" alt="WhatsApp icon" />
          </a>
        </div>
      </section>
    </PageShell>
  );
}
